const candidateJsonSchema = [
  {
    type: 'group',
    fields: [
      {
        name: 'firstName',
        label: 'First Name',
        type: 'text',
        showInList: true,
        required: true
      },
      {
        name: 'lastName',
        label: 'Last Name',
        type: 'text',
        required: true,
        showInList: true
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'email',
        label: 'Email',
        type: 'email',
        showInList: true,
        required: true
      },
      {
        name: 'personalMobile',
        label: 'Phone Number',
        type: 'text'
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'linkedinProfile',
        label: 'LinkedIn Profile',
        type: 'text',
        placeholder: 'https://linkedin.com/in/username'
      },
      {
        name: 'website',
        label: 'Portfolio/Website',
        type: 'text',
        placeholder: 'https://example.com'
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'currentPosition',
        label: 'Current Position',
        type: 'text',
        showInList: true
      },
      {
        name: 'currentCompany',
        label: 'Current Company',
        type: 'text'
      }
    ]
  },
  {
    type: 'group',
    fields: [
      {
        name: 'yearsOfExperience',
        label: 'Years of Experience',
        type: 'number',
        min: 0
      },
      {
        name: 'expectedSalary',
        label: 'Expected Salary',
        type: 'text',
        placeholder: '£50,000 - £60,000'
      }
    ]
  },
  {
    name: 'skills',
    label: 'Skills',
    type: 'textarea',
    placeholder: 'e.g., JavaScript, React, Node.js, etc.',
    rows: 3
  },
  {
    name: 'cv',
    label: 'Upload CV/Resume',
    type: 'fileUploader',
    accept: '.pdf,.doc,.docx',
    showInList: false,
    required: false
  },
  {
    name: 'notes',
    label: 'Notes',
    type: 'textarea',
    placeholder: 'Additional notes about the candidate...',
    rows: 4,
    showInList: false
  }
];

export default candidateJsonSchema;
